// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"1a27a0c6","658":"1a27a0c6","888":"d778ab21","925":"1a27a0c6"}[chunkId] + ".chunk.css";
};